package dev.krno.components

import androidx.compose.runtime.Composable
import dev.krno.data.EventData
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Footer
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun SiteFooter() {
    Footer(attrs = { classes("wrap") }) {
        Div {
            Text("© 2026 BrnKo · Brno Kotlin")
            Span(attrs = { classes("reg") }) { Text("®") }
            Text(" User Group")
        }
        // The whole credit line carries the Anton/orange treatment rather than
        // just the word "Kotlin" — the Kotlin Foundation brand guidelines ask
        // that the trademark not be styled differently from surrounding text.
        Div(attrs = { classes("powered") }) {
            Text("Written in Kotlin · Compose HTML")
        }
        Div(attrs = { classes("flinks") }) {
            A(href = "#program") { Text("Program") }
            A(href = "#register") { Text("Register") }
            A(href = "#venue") { Text("Venue") }
            A(href = "/code-of-conduct") { Text("Code of Conduct") }
            A(href = "mailto:${EventData.CONTACT_EMAIL}", attrs = { classes("mail") }) {
                Text(EventData.CONTACT_EMAIL)
            }
        }
        // Kodee is CC BY 4.0 — attribution is a licence condition, not a
        // courtesy. The independence line is discretionary (the Foundation may
        // ask for one); it names the Foundation only, since JetBrains does
        // sponsor the meetup and appears in Partners.
        Div(attrs = { classes("legal") }) {
            Div {
                Text("Kodee by JetBrains s.r.o. is licensed under ")
                A(href = "https://creativecommons.org/licenses/by/4.0/") { Text("CC BY 4.0") }
            }
            Div {
                Text("BrnKo is an independent community user group, not affiliated with ")
                Text("or endorsed by the Kotlin Foundation.")
            }
        }
    }
}
